module.exports = __webpack_public_path__ + "static/media/gift-win-2.36a1dc62.png";